$(document).ready(function() {
	var
		cookie = $.cookie('BX_USERTYPE_3');

	$('#USERTYPE').on('change', function() {
		setCookie('BX_USERTYPE_3', $('#USERTYPE').val());
		
		location.reload();
	});
});